export const AUTH_ROUTING = [
    {
        path: '/tai-khoan',
        name: 'auth',
        component: () => import('./Auth.vue'),
        meta: { noAuth: true },
        redirect: '/tai-khoan/dang-nhap',
        children: [
            {
                path: '/tai-khoan/dang-nhap',
                name: 'login',
                component: () => import('./components/Login.vue'),
                meta: {
                    mainPage: true
                }
            },
            {
                path: '/tai-khoan/dang-ky',
                name: 'register',
                component: () => import('./components/Register.vue'),
                meta: {
                    mainPage: true
                }
            },
            {
                path: '/tai-khoan/quen-mat-khau',
                name: 'forgot',
                component: () => import('./components/Forgot.vue'),
                meta: {
                    mainPage: true
                }
            },
            {
                path: '/tai-khoan/thong-bao',
                name: 'notify',
                component: () => import('./components/Notify.vue'),
            },
            {
                path: '/tai-khoan/thong-bao/:type',
                name: 'notify-type',
                component: () => import('./components/Notify.vue'),
            },
            {
                path: '/xac-minh-email/:token',
                name: 'verify-email',
                component: () => import('./components/VerifyEmail.vue'),
                children: []
            },
        ],
    },
];
